import axios from 'axios'

export const getPage = (paginacao,  ordenacao, filtro) => {
        const queryStringPaginacao = Object.keys(paginacao)
                .map((key) => `${key}=${paginacao[key]}`)
                .join('&');
        const queryStringOrdenacao = Object.keys(ordenacao)
                .map((key) => `${key}=${ordenacao[key]}`)
                .join('&');
        const queryStringFiltro = Object.keys(filtro)
                .map((key) => `${key}=${filtro[key]}`)
                .join('&');

        const querys = queryStringPaginacao +'&'+ queryStringOrdenacao + '&'+queryStringFiltro

        return axios.get(`/formulario/pesquisa?${querys}`)
}

export const getAll = () => axios.get(`/formulario/`)
export const excluir = (id) => axios.delete(`/formulario/${id}`)
export const cadastrar = (data) => axios.post(`/formulario`, data)
export const atualizar = (id, data) => axios.put(`/formulario/${id}`, data)
export const getById = (id) => axios.get(`/formulario/${id}`)
export const ativar = (id) => axios.post(`/formulario/${id}/ativar`)
export const inativar = (id) => axios.post(`/formulario/${id}/inativar`)